<script setup>
import CountDown from '@/components/Countdown/index.vue'
import { watch, onMounted, ref } from 'vue'
import { queryExamTimeInfo, listExamExplain } from '@/api/exam'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import DevicePixelRatio from '@/utils/devicePixelRatio'
import Store from "@/store";
import { actions } from '@/micros/index.js'

dayjs.extend(duration)

let info = ref({})
let examTimeInfo = ref({})

watch(
  () => Store.state.showExamExplain,
  async (e) => {

    if (!e) return
    // 获取说明信息
    await getInfo()
    // 获取考试类型列表
    getExamTypeList()
    // 获取考试流程
    getStepsList()
  }
)

// 获取说明弹窗需要的数据
async function getInfo() {

  info.value = Store.state.examExplainInfo || (sessionStorage.ExamExplain && JSON.parse(sessionStorage.ExamExplain))

  const res1 = await listExamExplain(info.value.signUpUserId, info.value.examId, info.value.paperId)
  if (res1.resCode !== 200) return

  if (res1.resData) {
    info.value = { ...info.value, ...res1.resData }
  }

  if (info.value.paperId) {
    info.value.leftTime = info.value.examLeftTime  || 0
  } else {
    info.value.leftTime = info.value.examDurationTime || 0
  }

  // 获取考试时间信息
  let res3 = await queryExamTimeInfo(info.value.examId)
  if (res3.resCode !== 200) return
  examTimeInfo.value = res3.resData
}

// 考试类型说明列表
let examTypeList = ref([])
// 获取考试类型说明
function getExamTypeList() {
  // 防切屏说明、人脸识别说明、人脸抓拍说明 是否显示
  examTypeList.value = [
    { id: 1, name: '防切屏说明', content: info.value.switchScreenExplain || '', count: info.value.examLimitSwitchScreenCount || 0 },
    { id: 2, name: '人脸识别说明', content: info.value.examFaceExplain || '' },
    { id: 3, name: '人脸抓拍说明', content: info.value.snapExplain || '' },
  ]

  let delType = []

  // 防切屏
  if (!info.value.isOpenExamPreventionCheat) delType.push(1)

  let t = info.value.examValidateType

  // 考试验证方式
  if ([1, 2].includes(t)) {
    delType.push(2, 3)
  } else if (t === 3) {
    delType.push(3)
  } else if ([4, 5].includes(t)) {
    delType.push(2)
  }

  examTypeList.value = examTypeList.value.filter(item => !delType.includes(item.id))
}

// 考试类型说明class
function typeClass(id) {
  return {
    'c-col-span-3': examTypeList.value.length === 1,
    'c-col-span-2': examTypeList.value.length === 2 && [2, 3].includes(id),
  }
}

// 默认步骤列表
let defStepsList = [
  { id: 1, name: '核验身份信息', isArrow: true, img: 'https://oss.caigou2003.com/ykt/Image/step_1.png' },
  { id: 2, name: '短信验证', isArrow: true, img: 'https://oss.caigou2003.com/ykt/Image/step_2.png' },
  { id: 3, name: '人脸识别', isArrow: true, img: 'https://oss.caigou2003.com/ykt/Image/step_3.png' },
  { id: 4, name: '人脸抓拍', isArrow: true, img: 'https://oss.caigou2003.com/ykt/Image/step_4.png' },
  { id: 5, name: '等待进入考试', isArrow: true, img: 'https://oss.caigou2003.com/ykt/Image/step_5.png' },
  { id: 6, name: '开始答题', isArrow: false, img: 'https://oss.caigou2003.com/ykt/Image/step_6.png' }
]

// 考试步骤列表
let examStepsList = ref([])

// 获取步骤列表
function getStepsList() {
  examStepsList.value = [...defStepsList]
  let type = info.value.examValidateType

  let delSteps = []
  if ([1, 2].includes(type)) {
    delSteps = [3, 4]
  } else if (type === 3) {
    delSteps = [2, 4]
  } else if (type === 4) {
    delSteps = [2]
  } else if (type === 5) {
    delSteps = [2, 3]
  }

  // 是否需要等待
  if (!examTimeInfo.value.isWait) {
    delSteps.push(5)
  }
  examStepsList.value = examStepsList.value.filter(item => !delSteps.includes(item.id))
}

function closeDialog() {
  actions.setGlobalState({
    showExamExplain: false,
    examExplainInfo: {}
  })
}

onMounted(() => {
  let d = new DevicePixelRatio()
  d.init()
})
</script>

<template>
  <div id="explain-dialog">
    <!--width="640px"-->
    <el-dialog :model-value="Store.state.showExamExplain" :close-on-click-modal="false" align-center :before-close="closeDialog" width="948px">
      <template #header>
        <div class="dialog-title">考试说明</div>
      </template>
      <div class="explain-content">
        <!-- 第一行 开始 ******************************************* -->
        <!-- 题型说明 -->
        <div class="explain-top">
          <div v-for="item in info.explainList" :key="item.id" class="explain-item"
            :class="{ 'c-col-span-2': item.explainType === 4 }">
            <div class="explain-name">{{ item.explainName }}</div>
            <div class="explain-count">{{ item.explainCount }}</div>
            <div class="explain-title">{{ item.explainTitle }}</div>
          </div>
        </div>
        <!-- 第一行 结束 ******************************************* -->

        <!-- 第二行 开始 ******************************************* -->
        <!-- 总分和时长 -->
        <div class="explain-top mt-2">
          <!-- 总分 -->
          <div class="explain-item">
            <div class="explain-name">合格分数</div>
            <div class="explain-count my-[8px]"><span class="count-big">{{ info.examPassingScore }}</span> 分</div>
            <div class="explain-title">满分{{ info.examFullScore }}分</div>
          </div>
          <div class="explain-item">
            <div class="explain-name">
              <span v-if="examTimeInfo.isDurationTime === 0">最晚交卷时间</span>
              <span v-else>{{ info.paperId ? '考试剩余时长' : '考试总时长' }}</span>
            </div>
            <div class="explain-count my-[8px]">
              <!-- 不固定时长模式 -->
              <template v-if="examTimeInfo.isDurationTime === 0">
                <div v-if="examTimeInfo.endAnswerTime" class="text-[26px] py-2">{{ examTimeInfo.endAnswerTime }}</div>
                <!-- 隐藏的倒计时 -->
                <CountDown v-if="Store.state.showExamExplain" :info="info" :onlyTime="true" class="w-0 h-0 overflow-hidden" />
              </template>
              <!-- 固定时长模式 正在考试中 -->
              <div v-else-if="info.paperId" class="count-big">
                <CountDown v-if="Store.state.showExamExplain" :info="info" :onlyTime="true" />
              </div>

              <!-- 固定时长模式，没有考试 -->
              <template v-else>
                <span v-if="info.examDurationTime" class="count-big">
                  {{ ~~(dayjs.duration(info.examDurationTime * 1000).asMinutes()) }}
                </span> 分钟
              </template>
            </div>
            <div class="explain-title">最早进入时间<br />{{ examTimeInfo.getIntoExamStartTime }}</div>
          </div>
          <div class="explain-item">
            <div class="explain-name">考试次数</div>
            <div class="explain-count my-[8px]" :class="{ 'my-10': info.isOpenNoLimitExam }">
              <span v-if="info.isOpenNoLimitExam" class="text-[36px]">不限</span>
              <template v-else>
                剩余 <span class="count-big">{{ info.surplusExamCount }}</span> 次
              </template>
            </div>
            <!-- `考试机会共${info.totalCount}次` -->
            <div class="explain-title whitespace-pre-wrap">{{ info.isOpenNoLimitExam ? '考试不限次数' : info.examCountNotice }}</div>
          </div>
        </div>
        <!-- 第二行 结束 ******************************************* -->

        <!-- 第三行 开始 ******************************************* -->
        <!-- 考试类型说明 -->
        <div class="explain-exam-type">
          <div v-for="item in examTypeList" class="explain-item" :class="typeClass(item.id)" :key="item.name">
            <div class="explain-name">{{ item.name }}</div>
            <div v-if="item.id === 1" class="explain-count">
              本场考试切屏{{ item.count }}次自动交卷
            </div>
            <div class="explain-title whitespace-pre-wrap" :class="{ 'mt-2': item.id !== 1 }">{{ item.content }}</div>
          </div>
        </div>
        <!-- 第三行 结束 ******************************************* -->

        <!-- 考试流程，步骤 -->
        <template v-if="examStepsList.length">
          <div class="exam-steps-title">考试流程</div>
          <div class="steps-list">
            <template v-for="item in examStepsList " :key="item.id">
              <div class="steps-item">
                <img class="steps-img" :src="item.img" alt="">
                <div class="steps-title">{{ item.name }}</div>
              </div>
              <img v-if="item.isArrow" src="@/assets/images/right_arrow.png" class="mx-2" alt="">
            </template>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
:deep(.el-dialog) {
  background-color: #F1F3FD;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 25px;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  //font-size: 25px;
  font-size: 35px;
  color: #363636;
}

.dialog-title {
  display: flex;
  align-items: center;
  justify-content: center;
  //font-size: 18px;
  font-size: 27px;
  font-weight: bold;
  color: #363636;
  padding-top: 20px;
  letter-spacing: 2px;
}

.explain-content {
  .explain-top {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .explain-item {
    text-align: center;
    padding: 13px 8px 8px;
    background-color: #fff;
    border-radius: 8px;
  }

  .explain-name {
    //font-size: 16px;
    font-size: 24px;
    color: #595959;
    font-weight: bold;
    letter-spacing: 2px;
  }

  .explain-count {
    //margin-top: 12px;
    //margin-bottom: 12px;
    margin-top: 17px;
    margin-bottom: 17px;
    color: #0E6FC1;
    //font-size: 14px;
    font-size: 21px;
  }

  .explain-title {
    //line-height: 18px;
    line-height: 30px;
    color: #555657;
    //font-size: 13px;
    font-size: 19px;
  }

  .count-big {
    //font-size: 30px;
    font-size: 44px;
  }

  .explain-exam-type {
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-top: 8px;
  }

  .exam-steps-title {
    //font-size: 18px;
    font-size: 27px;
    color: #363636;
    letter-spacing: 2px;
    font-weight: bold;
    margin-top: 20px;
  }

  .steps-list {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .steps-item {
    //width: 50px;
    //height: 50px;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 1px;
    position: relative;

    .steps-img {
      //width: 36px;
      width: 55px;
    }

    .steps-title {
      //font-size: 14px;
      font-size: 21px;
      color: #595959;
      position: absolute;
      bottom: -22px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
    }
  }

  .c-col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .c-col-span-2 {
    grid-column: span 2 / span 2 !important;
  }
}

::v-deep(.el-dialog__header) {
  padding: 0 !important;
}
</style>
